import { observer } from 'mobx-react';
import React from 'react';
import { PromiseMessage, PromiseRetry } from 'lib/components';
import { promiseStates, ReactNodeGenerator } from 'lib/helpers';
import { StudentHomeworkSceneStore } from '../student/StudentHomeworkSceneStore';
import { withTranslation, WithTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

interface IProps extends WithTranslation {
  store: StudentHomeworkSceneStore;
}

const ps = promiseStates;

function* renderer(store: StudentHomeworkSceneStore, t: TFunction): ReactNodeGenerator {
  const loader = store.homeworkLoader;

  yield (<PromiseMessage key="homework-load-message"
    state={loader}
    label={t('homework.loading')}
    align="center" />);

  yield (<PromiseRetry key="homework-load-retry"
    state={loader}
    retry={store.loadHomework}
    align="center" />);

  const dontReconnectMessage = store.hubStore.connection.dontReconnectMessage;
  if (dontReconnectMessage !== null) {
    yield (
      <div className="row justify-content-center" key="dont-reconnect-message">
        <div className="col-auto">
          <div className="alert alert-danger">
            {dontReconnectMessage}
          </div>
        </div>
      </div>);
  }
}

@observer
class HomeworkLoaderControls extends React.Component<IProps> {

  render() {
    return Array.from(renderer(this.props.store, this.props.t));
  }
}

export default withTranslation()(HomeworkLoaderControls);